// @ts-strict-ignore
import { onError } from "@apollo/client/link/error";
import { addBreadcrumb, captureException, type SeverityLevel } from "@sentry/react";

import { unauthorizedErrorRedirect } from "@helpers/unauthorizedErrorRedirect/unauthorizedErrorRedirect";
import { turnOffErrorReportingIfLoggedOut } from "@shared/utils/initSentry/filters/turnErrorsOff/turnErrorsOff";

const getErrorLink = (notify?, disableUnauthorizedCheck?: boolean) => {
  return onError(({ graphQLErrors, networkError, response }) => {
    addBreadcrumb({
      category: "apolloOnError",
      data: {
        networkError: JSON.stringify(networkError),
        response: JSON.stringify(response),
        graphQLErrors: JSON.stringify(graphQLErrors),
      },
      level: "info" as SeverityLevel,
    });

    if (networkError && "statusCode" in networkError && networkError.statusCode !== 403) {
      captureException(networkError, { level: "warning" });
    }

    if (
      networkError &&
      "statusCode" in networkError &&
      networkError.statusCode === 403 &&
      graphQLErrors?.[0]?.extensions?.code === "EMANCIPATED_DEPENDENT"
    ) {
      window.location.replace("/accounts");
    }

    turnOffErrorReportingIfLoggedOut(networkError, response);

    if (graphQLErrors && notify) {
      graphQLErrors.forEach(error => notify({ error }));
    }

    if (!disableUnauthorizedCheck) {
      unauthorizedErrorRedirect(networkError);
    }
  });
};

export { getErrorLink };
